import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { ForgotService } from "../shared/Forgot.Service";
import { AppInsightsService } from "../shared/AppInsights.Service";

@Component({
  selector: "app-identity-mgt-broker",
  templateUrl: "./identity-mgt-broker.component.html",
  styleUrls: ["./identity-mgt-broker.component.scss"]
})
export class IdentityMgtBrokerComponent implements OnInit {
  brokerType: string;
  showErrorMsg: boolean = false;

  showLifeText: boolean;
  view: string;
  isParamPresent: boolean = false;

  constructor(
    private router: Router,
    private forgotService: ForgotService,
    private appInsightsService: AppInsightsService,
    private activatedRoute: ActivatedRoute
  ) {
    this.activatedRoute.queryParams.subscribe(params => {
      if (Object.keys(params).length > 0) {
        this.isParamPresent = true;
        this.view = params["view"];
      }
    });
  }

  ngOnInit() {
    window.scrollTo(0, 0);

    if (this.isParamPresent && this.view === "life") {
      this.showLifeText = true;
      this.appInsightsService.logEvent("Forgot UI Page - Broker");
    } else if (!this.isParamPresent) {
      this.showLifeText = this.forgotService.lifeInsurance;
      this.appInsightsService.logEvent("Forgot UI Page - Broker");
    } else {
      this.router.navigate(["/404"]);
    }
  }
  continue() {
    if (
      this.brokerType == "" ||
      this.brokerType == null ||
      this.brokerType == undefined
    ) {
      this.showErrorMsg = true;
    } else if (this.brokerType == "non-appointed") {
      this.showErrorMsg = false;
      this.router.navigate(["broker/non-appointed"]);
    } else if (this.brokerType == "appointed") {
      this.showErrorMsg = false;
      this.router.navigate(["broker/appointed"]);
    }
  }

  cancel() {
    this.router.navigate([""]);
  }
}
